import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { BrgActiveStateFilter, BrgChartHeader, BrgValidationSummary } from '../models/Chart';


export default class ChartApi {
    private http: HTTPClient;
    private apiRoot: string;

    constructor(http: HTTPClient, apiRoot: string,) {
        this.http = http;
        this.apiRoot = apiRoot;
    }

    public async getBrgHeaderList(brgType: number, paging: PagingParams, pk_cuaa: number | null, campaign: number | null, statusFilter: BrgActiveStateFilter, customTotalCount: number | null, limit: number | null = null ): Promise<PagedResults<BrgChartHeader>>{
        let params: any = {
            brg_type_id: brgType,
            party_id: pk_cuaa,
            campaign: campaign,
            offset: paging.offset,
            count:  paging.count
        }

        if(limit !== null){
            params = {
                ...params,
                limit: limit
            }
        }

        if(statusFilter){
            params = {
                ...params,
                isValid: statusFilter.valid?1:0,
                isNotValid: statusFilter.invalid?1:0,
                toCheck: statusFilter.toCheck?1:0,
                isValidWithExemptions: statusFilter.validWithExemptions?1:0
            }
        }

        const res = await this.http.get(`${this.apiRoot}/v1/brg/summary/headers/list`, { params: params });
        if(customTotalCount !== null){
            res.data.totalcount = customTotalCount
        }
        return res.data as PagedResults<BrgChartHeader>;
    }

    public async getBrgHeaderListNoPag(brgType: number, pk_cuaa: number | null, campaign: number | null, statusFilter: BrgActiveStateFilter): Promise<BrgChartHeader[]>{
        const params: any = {
            brg_type_id: brgType,
            party_id: pk_cuaa,
            campaign: campaign,
        }
        const res = await this.http.get(`${this.apiRoot}/v1/brg/summary/headers/list`, { params: params });
        return res.data.records as BrgChartHeader[];
    }

    public async getRegisterSummary(brgType: number, pk_cuaa: number | null, campaign: number | null): Promise<BrgValidationSummary>{
        const res = await this.http.get(`${this.apiRoot}/v1/brg/summary/headers/validity`, {
            params: {
                brg_type_id: brgType,
                party_id: pk_cuaa,
                campaign: campaign
            }
        });
        return res.data;
    }

}
